module.exports = __webpack_public_path__ + "img/318.bcb6069d.png";